import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

import { SpConnectInterface } from '../interfaces/sp-connect.interface';
import { SpConnectHeaderDto } from './sp-connect-header.dto';
import { SpConnectItemDto } from './sp-connect-item.dto';
import { SpConnectOptionsDto } from './sp-connect-options.dto';
import { SpConnectSummaryDto } from './sp-connect-summary.dto';

export class SpConnectDto implements SpConnectInterface {
  @ApiProperty({ required: true })
  @IsOptional()
  @Type(() => SpConnectHeaderDto)
  header?: SpConnectHeaderDto;

  @ApiPropertyOptional()
  @IsOptional()
  @Type(() => SpConnectSummaryDto)
  summary?: SpConnectSummaryDto;

  @ApiProperty({ type: SpConnectItemDto, isArray: true })
  @IsOptional()
  @Type(() => SpConnectItemDto)
  items?: SpConnectItemDto[];

  @ApiProperty({ type: SpConnectOptionsDto, isArray: true })
  @IsOptional()
  @Type(() => SpConnectOptionsDto)
  options?: SpConnectOptionsDto[];
}
